import { render, staticRenderFns } from "./LandingCarousel.vue?vue&type=template&id=68666cc1&"
import script from "./LandingCarousel.vue?vue&type=script&lang=js&"
export * from "./LandingCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports